import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Loader} from '@components/common/base/loader'
import {Popup} from '@components/common/base/popup'
import {ProgressBar} from '@components/common/base/progress-bar/progress-bar'
import {useCompanyProjectsStore} from './company-projects-store'

export const ProjectImport = observer(() => {
  const [state, store] = useCompanyProjectsStore()

  if (!state.projectImportIsOpen) {
    return null
  }

  return (
    <Popup
      className="z-2000"
      autoHeight
      minHeight={200}
      width={440}
      close={store.projectImportClose}
      title={Lang.msg.importFromFile.importFromJsonFile}
    >
      {state.projectImportInProgress && (
        <div className="flex justify-center flex-col content-center">
          {!!state.projectImportName && (
            <div className="font-semibold mb-16 mx-auto">
              {`${Lang.msg.importFromFile.projectImportInProgress} ${state.projectImportName}`}
            </div>
          )}
          <div className="mx-auto">
            <Loader size="small" />
          </div>
          <ProgressBar
            value={state.projectImportProgress ?? 0}
            maxValue={100}
            className="w-200 mt-16 mx-auto"
          />
        </div>
      )}

      {!state.projectImportInProgress && !state.projectImportErrors.length && (
        <div className="text-success-old font-semibold mb-64">
          {`${state.projectImportName} ${Lang.msg.importFromFile.projectImportSuccess}`}
        </div>
      )}
      {state.projectImportErrors.map((error, i) => (
        <div className="text-error-old" key={i}>
          {error}
        </div>
      ))}
    </Popup>
  )
})
